export const API_URL = process.env.REACT_APP_API_URL;
export const APP_VERSION = process.env.APP_VERSION;
export const LOCIZE_API_KEY = process.env.REACT_APP_LOCIZE_API_KEY;
export const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID;
export const PRIVACY_POLICY_URL = process.env.PRIVACY_POLICY_URL;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const SENTRY_ENVIRONMENT =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || "development";
export const TERMS_AND_CONDITIONS_URL = process.env.TERMS_AND_CONDITIONS_URL;
